import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { RecordDisplaySettingComponent } from './record-display-setting/record-display-setting.component';
import { RecordDetailResolverService } from './record-detail-resolver.service';
import { UserRecordSelectComponent } from './user-record-select/user-record-select.component';
import { UserListResolverService } from '@app/resolvers/user-list-resolver.service';
import { RecordAddComponent } from './record-add/record-add.component';
import { RecordAddResolverService } from './record-add-resolver.service';
import { StaffListResolverService } from '@app/resolvers/staff-list-resolver.service';
import { RecordEditComponent } from './record-edit/record-edit.component';
import { ScheduleNoteEditComponent } from './schedule-note-edit/schedule-note-edit.component';
import { CanDeactivateGuardWebview } from '@app/can-deactivate.guard';
import { FacesheetEditComponent } from '@app/basic/facesheet/facesheet-edit/facesheet-edit.component';
import { FacesheetCreateComponent } from '@app/basic/facesheet/facesheet-create/facesheet-create.component';
import { FacesheetEditResolverService } from '@app/basic/facesheet/facesheet-edit-resolver.service';

const routes: Routes = [
  {
    path: 'user-record-select',
    component: UserRecordSelectComponent,
    resolve: { userList: UserListResolverService },
    outlet: 'edit',
  },
  {
    path: 'record-add',
    component: RecordAddComponent,
    resolve: {
      record: RecordAddResolverService,
      staffList: StaffListResolverService,
    },
    canDeactivate: [CanDeactivateGuardWebview],
    outlet: 'edit',
  },
  {
    path: 'schedule-note-edit/:noteid',
    component: ScheduleNoteEditComponent,
    resolve: {
      note: RecordDetailResolverService,
      staffList: StaffListResolverService,
    },
    canDeactivate: [CanDeactivateGuardWebview],
    outlet: 'edit',
  },
  {
    path: 'record-edit/:noteid',
    component: RecordEditComponent,
    resolve: {
      record: RecordDetailResolverService,
      staffList: StaffListResolverService,
    },
    canDeactivate: [CanDeactivateGuardWebview],
    outlet: 'edit',
  },
  {
    path: 'facesheet-edit',
    component: FacesheetEditComponent,
    resolve: {
      record: FacesheetEditResolverService
    },
    canDeactivate: [CanDeactivateGuardWebview],
    outlet: 'edit',
  },
  {
    path: 'facesheet-create',
    component: FacesheetCreateComponent,
    resolve: {
      record: RecordAddResolverService
    },
    canDeactivate: [CanDeactivateGuardWebview],
    outlet: 'edit',
  },
  {
    path: 'facesheet-duplicate/:noteid',
    component: FacesheetCreateComponent,
    resolve: {
      record: FacesheetEditResolverService
    },
    canDeactivate: [CanDeactivateGuardWebview],
    outlet: 'edit',
  },
  {
    path: 'record-display-setting',
    component: RecordDisplaySettingComponent,
    resolve: {
      userList: UserListResolverService,
      staffList: StaffListResolverService,
    },
    outlet: 'edit',
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class RecordRoutingModule { }
